import { render, staticRenderFns } from "./DomainPrivateWhoisStatus.vue?vue&type=template&id=41a3f12b&"
import script from "./DomainPrivateWhoisStatus.vue?vue&type=script&lang=js&"
export * from "./DomainPrivateWhoisStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports